export default __webpack_public_path__ + "static/media/travis.94a3b57c.png";